import React, {  forwardRef, useImperativeHandle, useState, useEffect, useRef } from "react";

const PositiveNumberEditor = forwardRef((props, ref) => {
  const [value, setValue] = useState(props.value);
  const inputRef = useRef();

  useImperativeHandle(ref, () => ({
    getValue: () => value,
  }));

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const handleKeyDown = (e) => {
    if (e.key === '-' || e.key === 'e' || e.key === 'E' || e.key === '+') {
      e.preventDefault();
    }
    if (e.key === '.' && (!value || value.length === 0)) {
      e.preventDefault();
    }
  };

  return (
    <input
      ref={inputRef}
      type="number"
      value={value}
      onChange={(e) => setValue(e.target.value)}
      onKeyDown={handleKeyDown}
      style={{ width: '100%', height: '100%', border: 'none', padding: '0 8px' }}
    />
  );
});
export default PositiveNumberEditor;
